<div style="min-width: 70vw !important;background-color:white; border-radius:5px;padding: 0px 15px 0px 0px;">

  <div class="modal-header">
    <h4 class="modal-title pull-left">Nouvelle &eacute;quivalence</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div (ngSubmit)="onSubmit()">
    <div class="modal-body">

      <div><label class="labelprogramme">DU PROGRAMME :</label>&nbsp;<strong>{{ fromProgrammeName }} ({{ fromProgrammeCode }})</strong></div>

      <table class="table table-hover" style="padding-left:1px;">
        <tr>
          <th class="col-check"></th>
          <th class="col-numero">Numéro</th>
          <th class="col-code">Code</th>
          <th class="col-enonce">Énoncé de compétence</th>
        </tr>
        <ng-container *ngFor="let fromCompetence of fromCompetences; let i = index">
          <tr>
            <td class="col-check">
              <input type="checkbox" (change)="onFromChange(fromCompetence.competenceId, $event.target.checked)" />
            </td>
            <td class="col-numero">
              {{ fromCompetence.numero }}
            </td>
            <td class="col-code">
              {{ fromCompetence.code }}
            </td>
            <td class="col-enonce">
              {{ fromCompetence.enonce }}
            </td>
          </tr>
        </ng-container>
      </table>


      <div><label class="labelprogramme">VERS LE PROGRAMME :</label>&nbsp;<strong>{{ toProgrammeName }} ({{ toProgrammeCode }})</strong></div>

      <table class="table table-hover">
        <tr>
          <th class="col-check"></th>
          <th class="col-numero">Numéro</th>
          <th class="col-code">Code</th>
          <th class="col-enonce">Énoncé de compétence</th>
        </tr>
        <ng-container *ngFor="let toCompetence of toCompetences; let i = index">
          <tr>
            <td class="col-check">
              <input type="checkbox" (change)="onToChange(toCompetence.competenceId, $event.target.checked)" />
            </td>
            <td class="col-numero">
              {{ toCompetence.numero }}
            </td>
            <td class="col-code">
              {{ toCompetence.code }}
            </td>
            <td class="col-enonce">
              {{ toCompetence.enonce }}
            </td>
          </tr>
        </ng-container>
      </table>

      <div><strong>Ces comp&eacute;tences communes reconnues sont...</strong></div>

      <select id="statut" style="margin-top: 10px;width:205px;">
        <option value="null" selected disabled>...</option>
        <option value="0">&Eacute;quivalentes</option>
        <option value="1">Identiques</option>
      </select>

    </div>

    <div class="modal-footer">
      <button type="submit" class="btn btn-info" [disabled]="isLoading" (click)="onSubmit()">
        <span [style.display]="isLoading ? 'inline-block' : 'none'" class="fa fa-refresh spinning"></span>
        Sauvegarder
      </button>
      <button type="button" class="btn btn-default" [disabled]="isLoading" (click)="cancel()">Annuler</button>
    </div>

  </div>

</div>
